/** Scene mode an input binding is valid in. */
export enum InputContext {
    Placement = 'placement',
    Navigation = 'navigation',
    Transformation = 'transformation',
    Configuration = 'configuration',
    View = 'view'
}
